import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { validateHwSerials } from '~/features/base/utils/hwSerialValidator';
import MultiselectOTA from '../../../base/components/forms/ota/MultiselectOTA';
import { useFetchVehicleGroupsQuery } from '~/api/vehicleGroup/VehicleGroup.api';
import TextAreaFormItem from '~/features/base/components/forms/TextAreaFormItem';
import { FILTER_IDS } from '~/features/devices/constants/filterMenuConstants';
import HeartWrapper from '~/features/devices/components/deviceFilters/HeartWrapper';

interface ExcludeDevicesSectionProps {
    control: Control<any>;
}

const ExcludeDevicesSection: React.FC<ExcludeDevicesSectionProps> = ({ control }) => {
    const { data: groups = [] } = useFetchVehicleGroupsQuery({});
    const groupOptions = groups.map(group => group.name);

    return (
        <div>
            <h4><FormattedMessage id='intl-msg:excludeDevices' defaultMessage='Exclude Devices'/></h4>
            <hr/>
            <div id={FILTER_IDS.GROUPS_BLACKLIST}>
                {groups.length > 0 ? (
                    <HeartWrapper key={`groups-blacklist-${groups.length}`}>
                        <Controller
                            name='vehicleGroupBlacklist'
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <MultiselectOTA
                                    labelId='intl-msg:excludeGroups'
                                    options={groupOptions}
                                    value={value}
                                    onChange={onChange}
                                />
                            )}
                        />
                    </HeartWrapper>
                ) : (
                    <Controller
                        name='vehicleGroupBlacklist'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <MultiselectOTA
                                labelId='intl-msg:excludeGroups'
                                options={groupOptions}
                                value={value}
                                onChange={onChange}
                            />
                        )}
                    />
                )}
            </div>
            <div id={FILTER_IDS.DEVICE_BLACKLIST}>
                <HeartWrapper>
                    <Controller
                        name='deviceBlacklist'
                        control={control}
                        render={({ field: { value = [], onChange } }) => {
                            const normalizedValue = Array.isArray(value) ? value : typeof value === 'string' ? [value] : [];
                            return (
                                <TextAreaFormItem
                                    values={normalizedValue}
                                    label='intl-msg:excludeDevices'
                                    placeholder='Enter device IDs separated by commas...'
                                    validate={validateHwSerials}
                                    onChange={({ values }) => onChange(values)}
                                    errorMessage={'intl-msg:listContainsInvalidSerialNumber'}
                                />
                            );
                        }}
                    />
                </HeartWrapper>
            </div>

        </div>
    );
};

export default ExcludeDevicesSection;
